import { FC, useState } from "react";
import { Fade, Paper, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { TooltipStyled } from "./TooltipStyled";
import IconComponent from "../components/ui/IconComponent";
import { copyToClipboard } from "../_utils/copyToClipboard";
import { BADGE_PAPER_STYLES } from "../_app/consts";
import BadgeStatus from "./BageStatus/BadgeStatus";
import { BotSeverity } from "../_app/types";
import Text from "./Text";
import { useTranslation } from "react-i18next";

interface CardHeaderProps {
  value: string;
  status: BotSeverity;
  outOfRange?: boolean;
  charLength?: number;
  headerColor?: string;
}

const CardHeader: FC<CardHeaderProps> = ({ value, status, outOfRange }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleCopiedTooltip = async () => {
    let copied = await copyToClipboard(value);
    if (copied) {
      copyToClipboard(value);
      setOpen(true);

      setTimeout(() => {
        setOpen(false);
      }, 1600);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        padding: "16px 16px 8px 16px",
        borderBottomLeftRadius: "0 !important",
        borderBottomRightRadius: "0 !important",
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        backgroundColor: theme.myTheme.colors.gray300,
      }}
    >
      <Stack direction="row" justifyContent="space-between">
        <Stack alignItems="center" direction="row">
          <Text variant="s" color={theme.myTheme.colors.foreground50}>
            {`ID: ${value}`}
          </Text>
          <TooltipStyled
            slots={{ transition: Fade }}
            slotProps={{
              transition: { timeout: 600 },
            }}
            title={t("copiedToClipboard", { ns: "common" })}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
          >
            <Box sx={{ height: 18, marginLeft: "4px" }} onClick={() => handleCopiedTooltip()}>
              <IconComponent iconName={"Copy"} hasFill hasStroke />
            </Box>
          </TooltipStyled>
        </Stack>

        <Stack direction={"row"} spacing={1}>
          {outOfRange && !["SHUTDOWN", "ERROR", "OPENING", "CLOSING"].includes(status ?? "") && (
            <Paper
              elevation={0}
              sx={{
                ...BADGE_PAPER_STYLES,
                backgroundColor: "#ECD904",
              }}
            >
              <Text color={theme.myTheme.colors.black} variant="xs">
                {t("outOfRange", { ns: "botsList" })}
              </Text>
            </Paper>
          )}
          <BadgeStatus severity={status} />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default CardHeader;
